import { render, staticRenderFns } from "./SelectSubjectServices.vue?vue&type=template&id=38a8ac16&"
import script from "./SelectSubjectServices.vue?vue&type=script&lang=js&"
export * from "./SelectSubjectServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports